import { render, staticRenderFns } from "./DevSwitchPlanModal.vue?vue&type=template&id=491c5496&scoped=true&"
import script from "./DevSwitchPlanModal.vue?vue&type=script&lang=js&"
export * from "./DevSwitchPlanModal.vue?vue&type=script&lang=js&"
import style0 from "./DevSwitchPlanModal.vue?vue&type=style&index=0&id=491c5496&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "491c5496",
  null
  
)

export default component.exports